import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import { newLineToBr } from "utilities/newlinetobr";

interface Props {
  row: server.dto.AdvancingFormRow
}

export const AdvancingDeclinedText = ({ row }: Props) => {
  const lastModifiedUtc = moment.utc(row.lastModifiedUtc);

  return <div className="advancing-declined-text s1_small" title={formatWrittenDateTimeUtc(lastModifiedUtc)}>
    {row.actorName ?? "[unknown]"} declined this {lastModifiedUtc.fromNow()}{row.declinedReason && <>: &quot;{newLineToBr(row.declinedReason)}&quot;</>}
  </div>;
};
